export enum EntityReducers {
  sites = 'sites',
  pmZoneSites = 'pmZoneSites',
  preferences = 'preferences',
}
